'use client'

import { StytchB2BProvider } from '@stytch/nextjs/b2b'
import { stytchClient } from '@/utilities/stytch/stytchClient'
import { ReactNode } from 'react'

interface StytchAuthProviderProps {
  children: ReactNode
}

export const StytchAuthProvider = ({ children }: StytchAuthProviderProps) => {
  return <StytchB2BProvider stytch={stytchClient}>{children}</StytchB2BProvider>
}

export default StytchAuthProvider
